var _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueQuata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 506,
    height: 342,
    viewBox: "0 0 506 342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 2298.537px;\n        fill: #021d42;\n        font-family: \"Courier New\";\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u201C",
    className: "cls-1",
    transform: "matrix(0.48, 0, 0, 0.48, -68.794, 708.268)"
  }, "\u201C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueQuata);
export default __webpack_public_path__ + "static/media/blueQuata.1053c62cfda9c22840371350d67c758b.svg";
export { ForwardRef as ReactComponent };